import React, { FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
const Mobile: FC<HTMLAttributes<HTMLDivElement>> = ({
  ...rest
}) => <MobileWrapper {...rest} />;
export default Mobile;
const MobileWrapper = /*#__PURE__*/styled('div')({
  name: "MobileWrapper",
  class: "m37xw5r",
  propsAsIs: false
});

require("./Mobile.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Mobile.tsx");